export const replaceSpecial = (text:string) =>{
    let fullArray = [];
    let firstArray = text.split('<a href="https://forum.digikey.com/" id="tech-forum-link" target="_blank" track-data="ref_page_event=No Results – TechForum">')
        fullArray.push(firstArray[0])
    let secondArray = firstArray[1].split('</a>');
    for(let sentence of secondArray){
        fullArray.push(sentence);
    }
    return fullArray;
}
